import React, { useEffect } from "react";
import { useOneLoginFlow } from "../hooks";
import { useAuthContext } from "../hooks/useAuthContext";
/**
 * Login callback component.
 * Receives a redirect from OneLogin login page.
 *
 * @copyright 2021 Noom, Inc.
 * @author nikola
 */
export const LoginCallback = ({ successPath = "/", errorPath = "/login", children, }) => {
    var _a;
    const { loginCallback } = useOneLoginFlow();
    const { fallback } = (_a = useAuthContext()) !== null && _a !== void 0 ? _a : {};
    useEffect(() => {
        loginCallback(successPath, errorPath);
    }, []);
    return fallback || React.createElement(React.Fragment, null, children);
};
export default LoginCallback;
//# sourceMappingURL=LoginCallback.js.map